import 'sos-common/sass/style.scss'; //Common styles
import '../../sass/style.scss';
import * as EserviceCommon from 'sos-eservice-common/js/components';
import { SbgListClosed } from './SbgList/SbgListClosed/SbgListClosed';
import { SbgFilterList } from './SbgList/SbgFilterList';
import { SbgListAvailable } from './SbgList/SbgListAvailable/SbgListAvailable';
import { AddAuthorization } from './OrganizationAdmin/add.authorization';
import { ListPendingInvitations } from './OrganizationAdmin/list.pendingInvitations';
import { ListRepresentatives } from './OrganizationAdmin/list.representatives';
import * as CalculationComponents from './CalculationComponents';
import { StatsbidragCompletion } from './StatsbidragCompletion/StatsbidragCompletion';
import { StatsbidragFormMenu } from './StatsbidragFormMenu/StatsbidragFormMenu';
import { StatsbidragSubmitAction } from './StatsbidragSubmitAction/StatsbidragSubmitAction';
import { StatsbidragSubmitButton } from './StatsbidragSubmitButton/StatsbidragSubmitButton';
import { MessageBannerWrapper } from './MessageBannerWrapper/MessageBannerWrapper';
import { StatsbidragFormMenuController } from './StatsbidragFormMenuController/StatsbidragFormMenuController';
import { Validator } from './Validator/Validator';
import { Textualizer } from './Textualizer/Textualizer';
import { StatsbidragContactBlock } from './StatsbidragContactBlock/StatsbidragContactBlock';
import { StatsbidragWizardStepWrapper } from './StatsbidragWizardStepWrapper/StatsbidragWizardStepWrapper';
import { StatsbidragFileUploader } from './StatsbidragFileUploader/StatsbidragFileUploader';
import { StatsbidragDialogueError } from './StatsbidragDialogueError/StatsbidragDialogueError';
import { SbgPastApplicationsList } from './SbgPastApplicationsList/SbgPastApplicationList';
import { OmbudAnsokan } from './OmbudComponents/OmbudForm/Ombud';
import { OmbudCompletion } from './OmbudComponents/OmbudCompletion/OmbudCompletion';
import { DeleteOmbudButton } from './OmbudComponents/DeleteOmbudButton/DeleteOmbudButton';
//common components
import { MainMenu } from 'sos-common/js/components/MainMenu/MainMenu';
import { SiteHeader } from 'sos-common/js/components/SiteHeader/SiteHeader';
import { BreadCrumbs } from 'sos-common/js/components/BreadCrumbs/BreadCrumbs';
import { Notification } from 'sos-common/js/components/Notification/Notification';
import { Hero } from 'sos-common/js/components/Hero/Hero';
import { TagList } from 'sos-common/js/components/TagList/TagList';
import { Lazyloader } from 'sos-common/js/components/Lazyloader/Lazyloader';
import { ShareWidget } from 'sos-common/js/components/ShareWidget/ShareWidget';
import { Search } from 'sos-common/js/components/Search/Search';
import { SearchList } from 'sos-common/js/components/SearchList/SearchList';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { CurrentEvent } from 'sos-common/js/components/CurrentEvent/CurrentEvent';
import { CurrentCalendar } from 'sos-common/js/components/CurrentCalendar/CurrentCalendar';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { DesktopLanguagePicker } from 'sos-common/js/components/DesktopLanguagePicker/DesktopLanguagePicker';
import { TreeView } from 'sos-common/js/components/SubNavigation/TreeView';
import { ActualListening } from 'sos-common/js/components/ActualListening/ActualListening';
import { AcceptConditions } from 'sos-common/js/components/AcceptConditions/AcceptConditions';
import { SureDelete } from 'sos-common/js/components/SureDelete/SureDelete';
import { CalendarPageList } from 'sos-common/js/components/CalendarPageList/CalendarPageList';
import { CalendarArchiveList } from 'sos-common/js/components/CalendarArchiveList/CalendarArchiveList';
import { PrintButton } from 'sos-common/js/components/PrintButton/PrintButton';
import { NotificationFullWidth } from 'sos-common/js/components/NotificationFullWidth/NotificationFullWidth';
import { TextInputForPrint } from 'sos-common/js/components/FormControls/TextInputForPrint';
import { VideoBlock } from 'sos-common/js/components/VideoBlock/VideoBlock';
import { CookieConsentManager } from 'sos-common/js/components/CookieConsentManager/CookieConsentManager';
import { LinkPuff } from 'sos-common/js/components/LinkPuff/LinkPuff';
import { TabComponent } from 'sos-common/js/components/TabComponent/TabComponent';
import { ExpanderGroup } from 'sos-common/js/components/ExpanderGroup/ExpanderGroup';
import { Analytics } from 'sos-common/js/components/Analytics/Analytics';

const {
  AutoSum,
  ApplicationSum,
  SalaryExpenditures,
  Summary,
  Associations,
  AssociationsByCounty,
  ActivityGoalDescription,
  ActivityGoalBudget,
  MembersBySex,
  RequestedAmount,
} = CalculationComponents;

const { EServicesSiteHeader, EServiceFormMenu, SessionHandler } = EserviceCommon;

export {
  SessionHandler,
  PrintButton,
  MainMenu,
  SiteHeader,
  EServicesSiteHeader,
  Hero,
  BreadCrumbs,
  Notification,
  TagList,
  Lazyloader,
  ShareWidget,
  Search,
  CurrentEvent,
  CurrentCalendar,
  SearchList,
  Fileupload,
  Icon,
  TextInput,
  TextInputForPrint,
  CheckBox,
  Tooltip,
  DesktopLanguagePicker,
  TreeView,
  ActualListening,
  AcceptConditions,
  SureDelete,
  EServiceFormMenu,
  CalendarPageList,
  CalendarArchiveList,
  SbgListClosed,
  DeleteOmbudButton,
  OmbudCompletion,
  OmbudAnsokan,
  NotificationFullWidth,
  AddAuthorization,
  ListPendingInvitations,
  ListRepresentatives,
  AutoSum,
  Summary,
  ApplicationSum,
  SalaryExpenditures,
  Associations,
  MembersBySex,
  AssociationsByCounty,
  ActivityGoalDescription,
  ActivityGoalBudget,
  StatsbidragCompletion,
  StatsbidragFormMenu,
  StatsbidragSubmitAction,
  StatsbidragSubmitButton,
  MessageBannerWrapper,
  StatsbidragFormMenuController,
  Validator,
  StatsbidragContactBlock,
  StatsbidragWizardStepWrapper,
  StatsbidragFileUploader,
  StatsbidragDialogueError,
  RequestedAmount,
  Textualizer,
  VideoBlock,
  CookieConsentManager,
  LinkPuff,
  TabComponent,
  ExpanderGroup,
  SbgFilterList,
  SbgListAvailable,
  SbgPastApplicationsList,
  Analytics,
};
